import { tryCatch } from './tryCatch';
const defaultOptions = {
  retries: 3,
  delayMs: 1000
};
const delay = timeoutMs => new Promise(resolve => setTimeout(resolve, timeoutMs));

/**
 * Does the retry of the asynchronous function for options.retries number of times (default 3) and with delay between calls options.delayMs ms (default 1000).
 * @example
 * const result = await retry(
 *   () => myAsyncHandler(handlerParams),
 *   { retries: 5, delayMs: 300 },
 * )
 * @example
 * const result = await retry(
 *   ({ abort }) => {
 *     const [error, result] = await tryCatch(() => myAsyncHandler(handlerParams))
 *     if (error) {
 *       if (error instanceof ExpectedError) {
 *         return abort(error)
 *       }
 *       throw error
 *     }
 *     return result
 *   },
 *   { retries: 5, delayMs: 300 },
 * )
 */
export const retry = async function (fn, options) {
  if (options === void 0) {
    options = {};
  }
  const delayMs = options.delayMs !== undefined ? options.delayMs : defaultOptions.delayMs;
  let retries = options.retries !== undefined ? options.retries : defaultOptions.retries;
  if (retries < 1) {
    throw new Error('retries count should be >= 1');
  }
  let lastResult;
  let abortError;
  const abort = error => {
    abortError = error;
    throw abortError;
  };
  do {
    lastResult = await tryCatch(() => fn({
      abort
    }));
    if (abortError) {
      throw abortError;
    }
    const _lastResult = lastResult,
      error = _lastResult[0];
    if (error) {
      // TODO: handle aborts
      await delay(delayMs);
    } else {
      break;
    }
    retries -= 1;
  } while (retries > 0);
  const _lastResult2 = lastResult,
    error = _lastResult2[0],
    result = _lastResult2[1];
  if (error) {
    throw error;
  }
  return result;
};
//# sourceMappingURL=retry.js.map